import {
  Box,
  Button,
  Chip,
  CircularProgress,
  Grid,
  Modal,
} from "@mui/material";
import { contentStyle, wrapperStyle } from "./style";
import { LogSummary, ParsedLog, useAPI } from "../../../../../api/useAPI";
import { useState, useEffect, ReactNode } from "react";
import { SimpleTreeView } from "@mui/x-tree-view/SimpleTreeView";
import { TreeItem } from "@mui/x-tree-view";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import LogsContentModal from "../content-modal/LogsContentModal";

interface Props {
  handleClose: () => void;
  open: boolean;
}

export default ({ open, handleClose }: Props) => {
  const { getLogsOverview } = useAPI();
  const [overview, setOverview] = useState<LogSummary[]>([]);
  const [currentLogGroup, setCurrentLogGroup] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [contentModal, setContentModal] = useState(false);

  useEffect(() => {
    setLoading(true);
    getLogsOverview()
      .then((response) => {
        setLoading(false);
        if (!response.success) {
          throw new Error(response.error);
        }

        setOverview(response.data);
      })
      .catch((err) => {
        console.error(err);
        setError(`Error during fetching of logs overview: ${err.message}`);
      });
  }, [open]);

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-descripiton"
    >
      <Grid container sx={wrapperStyle}>
        <LogsContentModal
          handleClose={() => setContentModal(false)}
          open={contentModal}
          logGroup={currentLogGroup}
        />
        {error ? (
          error
        ) : loading ? (
          <Box sx={{ textAlign: "center", mt: 4 }}>
            <CircularProgress />
          </Box>
        ) : (
          <Grid sx={contentStyle}>
            <SimpleTreeView expansionTrigger="iconContainer">
              {overview.map((logSummary) => (
                <TreeItem
                  itemId={logSummary.logGroup}
                  label={
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      {logSummary.logGroup}
                      &nbsp;
                      {renderChips(logSummary.summary)}
                      <Box sx={{ marginLeft: "auto" }}>
                        <KeyboardDoubleArrowRightIcon
                          onClick={() => {
                            setCurrentLogGroup(logSummary.logGroup);
                            setContentModal(true);
                          }}
                        />
                      </Box>
                    </Box>
                  }
                >
                  {logSummary.archiveLogs.slice(0, 10).map((archiveLog) => (
                    <TreeItem
                      itemId={archiveLog}
                      label={archiveLog}
                      onClick={() => {
                        setCurrentLogGroup(archiveLog);
                        setContentModal(true);
                      }}
                    />
                  ))}
                </TreeItem>
              ))}
            </SimpleTreeView>
          </Grid>
        )}
      </Grid>
    </Modal>
  );
};

function renderChips(currentSummary: ParsedLog | undefined): ReactNode {
  if (!currentSummary) {
    return null;
  }

  if (currentSummary?.errors === 0 && currentSummary?.warinings === 0) {
    return <Chip size="small" label="Clean" color="info" />;
  }
  return (
    <>
      {currentSummary?.errors === 0 ? null : (
        <Chip
          size="small"
          label={`${currentSummary?.errors} errors`}
          color="error"
        />
      )}

      {currentSummary?.warinings === 0 ? null : (
        <Chip
          size="small"
          label={`${currentSummary?.warinings} warnings`}
          color="warning"
        />
      )}
    </>
  );
}
